export default "__VITE_ASSET__CXdolOtM__"